/* ============================================
   SeaDeck Kits Online — Scroll Animations
   Apple-inspired reveal effects
   ============================================ */

(function() {
  'use strict';

  // --- Scroll Reveal via Intersection Observer ---
  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sd-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });

    // Auto-tag Dawn sections for reveal
    var sections = document.querySelectorAll(
      '.shopify-section .rich-text-wrapper,' +
      '.shopify-section .multicolumn,' +
      '.shopify-section .collection-list,' +
      '.shopify-section .image-with-text,' +
      '.shopify-section .newsletter,' +
      '.shopify-section .featured-collection'
    );

    sections.forEach(function(el) {
      if (!el.classList.contains('sd-reveal')) {
        el.classList.add('sd-reveal');
        observer.observe(el);
      }
    });

    // Product cards get stagger
    var grids = document.querySelectorAll('.collection .grid, .featured-collection .grid');
    grids.forEach(function(grid) {
      if (!grid.classList.contains('sd-stagger')) {
        grid.classList.add('sd-stagger');
        grid.classList.add('sd-reveal');
        observer.observe(grid);
      }
    });

    // Observe any manually-tagged elements
    document.querySelectorAll('.sd-reveal, .sd-reveal-left, .sd-reveal-right, .sd-reveal-scale').forEach(function(el) {
      observer.observe(el);
    });
  }

  // --- Header Scroll State ---
  function initHeaderScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;

    var lastScroll = 0;
    window.addEventListener('scroll', function() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = scrollY;
    }, { passive: true });
  }

  // --- Scroll Progress Bar ---
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.className = 'sd-scroll-progress';
    document.body.prepend(bar);

    window.addEventListener('scroll', function() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var progress = (scrollTop / docHeight) * 100;
      bar.style.width = progress + '%';
    }, { passive: true });
  }

  // --- Smooth Anchor Scroll ---
  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var headerHeight = document.querySelector('.header-wrapper') ? document.querySelector('.header-wrapper').offsetHeight : 0;
          var targetPos = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
          window.scrollTo({ top: targetPos, behavior: 'smooth' });
        }
      });
    });
  }

  // --- Image Fade-In on Load ---
  function initImageFadeIn() {
    var images = document.querySelectorAll('.card__media img, .banner__media img, .image-with-text__media-item img');
    images.forEach(function(img) {
      if (img.complete) {
        img.style.opacity = '1';
      } else {
        img.style.opacity = '0';
        img.style.transition = 'opacity 0.6s ease';
        img.addEventListener('load', function() {
          this.style.opacity = '1';
        });
      }
    });
  }

  // --- Number Counter Animation ---
  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute('data-counter'), 10);
          var duration = 2000;
          var startTime = null;

          function animate(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = Math.floor(eased * target);
            el.textContent = current.toLocaleString();
            if (progress < 1) requestAnimationFrame(animate);
            else el.textContent = target.toLocaleString();
          }

          requestAnimationFrame(animate);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(c) { observer.observe(c); });
  }

  // --- Init All ---
  function init() {
    initScrollReveal();
    initHeaderScroll();
    initScrollProgress();
    initSmoothAnchors();
    initImageFadeIn();
    initCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();